/*
 *
 * This is the source for node package react-validation https://github.com/Lesha-spr/react-validation
 * There is no activity from the author
 * There was a bug that we had to implement a custom fix for.
 *
 *
 */

// jshint ignore: start

!function (e, t) {
    "object" === typeof exports && "object" === typeof module ? module.exports = t(require("react"), require("prop-types"), require("uuid/v4"), require("lodash.omit")) : "function" === typeof define && define.amd ? define(["react", "prop-types", "uuid/v4", "lodash.omit"], t) : "object" === typeof exports ? exports.main = t(require("react"), require("prop-types"), require("uuid/v4"), require("lodash.omit")) : e.main = t(e.React, e.PropTypes, e.uuid, e["_.omit"])
}(this, function (e, t, r, n) {
    return function (e) {
        function t(n) {
            if (r[n])
                return r[n].exports;
            var o = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, t),
                o.l = !0,
                o.exports
        }
        var r = {};
        return t.m = e,
            t.c = r,
            t.d = function (e, r, n) {
                t.o(e, r) || Object.defineProperty(e, r, {
                    configurable: !1,
                    enumerable: !0,
                    get: n
                })
            }
            ,
            t.n = function (e) {
                var r = e && e.__esModule ? function () {
                    return e.default
                }
                    : function () {
                        return e
                    }
                    ;
                return t.d(r, "a", r),
                    r
            }
            ,
            t.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t)
            }
            ,
            t.p = "/",
            t(t.s = 10)
    }([function (t, r) {
        t.exports = e
    }
        , function (e, r) {
            e.exports = t
        }
        , function (e, t, r) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function o(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" !== typeof t && "function" !== typeof t ? e : t
            }
            function i(e, t) {
                if ("function" !== typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                    t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function a(e) {
                var t, r;
                return r = t = function (t) {
                    function r() {
                        return n(this, r),
                            o(this, (r.__proto__ || Object.getPrototypeOf(r)).apply(this, arguments))
                    }
                    return i(r, t),
                        f(r, [{
                            key: "render",
                            value: function () {
                                var t = this.context._getProps(this.id);
                                return t ? u.a.createElement(e, Object.assign({}, t, {
                                    onChange: this.handleChange,
                                    onBlur: this.handleBlur
                                })) : null
                            }
                        }]),
                        r
                }(c.a),
                    t.displayName = "Control(" + e.name + ")",
                    r
            }
            t.a = a;
            var s = r(0)
                , u = r.n(s)
                , c = r(3)
                , f = function () {
                    function e(e, t) {
                        for (var r = 0; r < t.length; r++) {
                            var n = t[r];
                            n.enumerable = n.enumerable || !1,
                                n.configurable = !0,
                                "value" in n && (n.writable = !0),
                                Object.defineProperty(e, n.key, n)
                        }
                    }
                    return function (t, r, n) {
                        return r && e(t.prototype, r),
                            n && e(t, n),
                            t
                    }
                }()
        }
        , function (e, t, r) {
            "use strict";
            function n(e, t) {
                var r = {};
                for (var n in e)
                    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                return r
            }
            function o(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function i(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" !== typeof t && "function" !== typeof t ? e : t
            }
            function a(e, t) {
                if ("function" !== typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                    t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            var s = r(0)
                , u = (r.n(s),
                    r(1))
                , c = r.n(u)
                , f = r(4)
                , l = r.n(f)
                , p = r(5)
                , b = r.n(p)
                , d = r(6)
                , y = r.n(d)
                , h = function () {
                    function e(e, t) {
                        for (var r = 0; r < t.length; r++) {
                            var n = t[r];
                            n.enumerable = n.enumerable || !1,
                                n.configurable = !0,
                                "value" in n && (n.writable = !0),
                                Object.defineProperty(e, n.key, n)
                        }
                    }
                    return function (t, r, n) {
                        return r && e(t.prototype, r),
                            n && e(t, n),
                            t
                    }
                }()
                , v = function (e) {
                    function t() {
                        var e, r, n, a;
                        o(this, t);
                        for (var s = arguments.length, u = Array(s), c = 0; c < s; c++)
                            u[c] = arguments[c];
                        return r = n = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(u))),
                            n.id = y()(),
                            n.handleChange = function (e) {
                                e.persist(),
                                    n.context._handleChange(e, n.id),
                                    n.props.onChange && n.props.onChange(e);
                            }
                            ,
                            n.handleBlur = function (e) {
                                e.persist(),
                                    n.context._handleBlur(e, n.id),
                                    n.props.onBlur && n.props.onBlur(e);
                            }
                            ,
                            a = r,
                            i(n, a)
                    }
                    return a(t, e),
                        h(t, [{
                            key: "componentDidMount",
                            value: function () {
                                this.context._register(this, this.id);
                            }
                        }, {
                            key: "componentWillUnmount",
                            value: function () {
                                this.context._unregister(this, this.id);
                            }
                        }, {
                            key: "componentWillReceiveProps",
                            value: function (e) {
                                var t = e.validations
                                    , r = n(e, ["validations"])
                                    , o = this.props
                                    , i = o.validations
                                    , a = n(o, ["validations"]);
                                b()(a, r) && l()(i, t) || this.context._setProps(r, this.id);
                            }
                        }, {
                            key: "shouldComponentUpdate",
                            value: function (e, t, r) {
                                return r !== this.context;
                            }
                        }, {
                            key: "render",
                            value: function () {
                                return null;
                            }
                        }]),
                        t
                }(s.Component);
            v.contextTypes = {
                _register: c.a.func.isRequired,
                _unregister: c.a.func.isRequired,
                _setProps: c.a.func.isRequired,
                _handleChange: c.a.func.isRequired,
                _handleBlur: c.a.func.isRequired,
                _getProps: c.a.func.isRequired
            },
                v.propTypes = {
                    validations: c.a.arrayOf(c.a.func),
                    onChange: c.a.func,
                    onBlur: c.a.func
                },
                v.defaultProps = {
                    validations: []
                },
                t.a = v
        }
        , function (e, t) {
            e.exports = function (e, t) {
                if (e === t)
                    return !0;
                var r = e.length;
                if (t.length !== r)
                    return !1;
                for (var n = 0; n < r; n++)
                    if (e[n] !== t[n])
                        return !1;
                return !0
            }
        }
        , function (e, t) {
            e.exports = function (e, t) {
                if (e === t)
                    return !0;
                var r = Object.keys(e)
                    , n = Object.keys(t)
                    , o = r.length;
                if (n.length !== o)
                    return !1;
                for (var i = 0; i < o; i++) {
                    var a = r[i];
                    if (e[a] !== t[a])
                        return !1
                }
                return !0
            }
        }
        , function (e, t) {
            e.exports = r
        }
        , function (e, t, r) {
            "use strict";
            function n(e, t) {
                var r = {};
                for (var n in e)
                    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                return r
            }
            function o(e, t, r) {
                return t in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r,
                    e
            }
            function i(e) {
                if (Array.isArray(e)) {
                    for (var t = 0, r = Array(e.length); t < e.length; t++)
                        r[t] = e[t];
                    return r
                }
                return Array.from(e)
            }
            function a(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function s(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" !== typeof t && "function" !== typeof t ? e : t
            }
            function u(e, t) {
                if ("function" !== typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                    t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function c(e) {
                var t, r, c;
                return r = t = function (t) {
                    function r(e, t) {
                        a(this, r);
                        var n = s(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e, t));
                        return c.call(n),
                            n.state = {
                                byName: {},
                                byId: {}
                            },
                            n
                    }
                    return u(r, t),
                        h(r, [{
                            key: "getChildContext",
                            value: function () {
                                var e = this;
                                return {
                                    _register: this._register,
                                    _unregister: this._unregister,
                                    _setProps: this._setProps,
                                    _handleChange: this._handleChange,
                                    _handleBlur: this._handleBlur,
                                    _getProps: this._getProps,
                                    _errors: Object.keys(this.state.byId).filter(function (t) {
                                        return e.state.byId[t].error
                                    })
                                }
                            }
                        }, {
                            key: "render",
                            value: function () {
                                return l.a.createElement(e, Object.assign({}, this.props, {
                                    validate: this.validate,
                                    validateAll: this.validateAll,
                                    getValues: this.getValues,
                                    showError: this.showError,
                                    hideError: this.hideError
                                }))
                            }
                        }]),
                        r
                }(f.PureComponent),
                    t.displayName = "Form(" + e.name + ")",
                    t.propTypes = {},
                    t.childContextTypes = {
                        _register: b.a.func.isRequired,
                        _unregister: b.a.func.isRequired,
                        _setProps: b.a.func.isRequired,
                        _handleChange: b.a.func.isRequired,
                        _handleBlur: b.a.func.isRequired,
                        _getProps: b.a.func.isRequired,
                        _errors: b.a.array
                    },
                    c = function () {
                        var e = this;
                        this._register = function (t, r) {
                            e.setState(function (e) {
                                return {
                                    byName: Object.assign({}, e.byName, o({}, t.props.name, [].concat(i(e.byName[t.props.name] || []), [r]))),
                                    byId: Object.assign({}, e.byId, o({}, r, Object.assign({}, t.props, {
                                        isCheckable: v(t),
                                        value: t.props.value || ""
                                    }, v(t) ? {
                                        checked: !!t.props.checked
                                    } : {})))
                                }
                            }, e._setErrors)
                        }
                            ,
                            this._unregister = function (t, r) {
                                e.setState(function (prevState) {
                                    var n = [].concat(i(prevState.byName[t.props.name]));
                                    n.splice(n.indexOf(r), 1);
                                    var a = n.length ? Object.assign({}, prevState.byName, o({}, t.props.name, n)) : y()(prevState.byName, t.props.name);

                                    return {
                                        byName: a,
                                        byId: y()(prevState.byId, r)
                                    };
                                });
                            }
                            ,
                            this._getProps = function (t) {
                                if (e.state.byId[t]) {
                                    var r = e.state.byId[t];
                                    r.validations,
                                        r.isCheckable;
                                    return n(r, ["validations", "isCheckable"])
                                }
                            }
                            ,
                            this._setProps = function (t, r) {
                                e.setState(function (e) {
                                    return {
                                        byId: Object.assign({}, e.byId, o({}, r, Object.assign({}, e.byId[r], t)))
                                    }
                                }, e._setErrors)
                            }
                            ,
                            this._handleChange = function (t, r) {
                                var n = e.state.byId[r].isCheckable;
                                e.setState({
                                    byId: Object.assign({}, e.state.byId, n ? Object.assign({}, e.state.byName[e.state.byId[r].name].reduce(function (t, r) {
                                        return t[r] = Object.assign({}, e.state.byId[r], {
                                            checked: !1
                                        }),
                                            t
                                    }, {})) : {}, o({}, r, Object.assign({}, e.state.byId[r], {
                                        isChanged: !0,
                                        value: t.target.value
                                    }, n && {
                                        checked: t.target.checked
                                    })))
                                }, e._setErrors)
                            }
                            ,
                            this._handleBlur = function (t, r) {
                                e.setState({
                                    byId: Object.assign({}, e.state.byId, o({}, r, Object.assign({}, e.state.byId[r], {
                                        isUsed: !0,
                                        value: t.target.value
                                    })))
                                }, e._setErrors)
                            }
                            ,
                            this._setErrors = function () {
                                e.setState(function (e) {
                                    return {
                                        byId: Object.keys(e.byId).reduce(function (t, r) {
                                            var n = e.byId[r].validations
                                                , o = e.byId[r]
                                                , i = Object.keys(e.byName).reduce(function (t, r) {
                                                    return t[r] = e.byName[r].map(function (t) {
                                                        return e.byId[t]
                                                    }),
                                                        t
                                                }, {})
                                                , a = o.value;
                                            t[r] = Object.assign({}, e.byId[r]);
                                            var s = !0
                                                , u = !1
                                                , c = void 0;
                                            try {
                                                for (var f, l = n[Symbol.iterator](); !(s = (f = l.next()).done); s = !0) {
                                                    var p = f.value
                                                        , b = p(a, o, i);
                                                    if (b) {
                                                        t[r].error = b;
                                                        break
                                                    }
                                                    delete t[r].error
                                                }
                                            } catch (e) {
                                                u = !0,
                                                    c = e
                                            } finally {
                                                try {
                                                    !s && l.return && l.return()
                                                } finally {
                                                    if (u)
                                                        throw c
                                                }
                                            }
                                            return t
                                        }, {})
                                    }
                                })
                            }
                            ,
                            this.getValues = function () {
                                return Object.keys(e.state.byName).reduce(function (t, r) {
                                    return e.state.byName[r].length > 1 ? t[r] = e.state.byName[r].map(function (t) {
                                        return e.state.byId[t].value
                                    }) : t[r] = e.state.byId[e.state.byName[r][0]].value,
                                        t
                                }, {})
                            }
                            ,
                            this.validate = function (t) {
                                e.setState(function (e) {
                                    return {
                                        byId: Object.assign({}, e.byId, e.byName[t].reduce(function (t, r) {
                                            return t[r] = Object.assign({}, e.byId[r], {
                                                isChanged: !0,
                                                isUsed: !0
                                            }),
                                                t
                                        }, {}))
                                    }
                                }, e._setErrors)
                            }
                            ,
                            this.validateAll = function () {
                                e.setState(function (e) {
                                    return {
                                        byId: Object.assign({}, e.byId, Object.keys(e.byName).reduce(function (t, r) {
                                            return e.byName[r].reduce(function (r, n) {
                                                return t[n] = Object.assign({}, e.byId[n], {
                                                    isChanged: !0,
                                                    isUsed: !0
                                                }),
                                                    r
                                            }, {}),
                                                t
                                        }, {}))
                                    }
                                }, e._setErrors)
                            }
                            ,
                            this.showError = function (t, r) {
                                t && setTimeout(function () {
                                    e.setState({
                                        byId: Object.assign({}, e.state.byId, o({}, t.id, Object.assign({}, e.state.byId[t.id], {
                                            isChanged: !0,
                                            isUsed: !0,
                                            error: r
                                        })))
                                    })
                                }, 0)
                            }
                            ,
                            this.hideError = function (t) {
                                e.setState(function (e) {
                                    return {
                                        byId: Object.assign({}, e.byId, o({}, t.id, Object.assign({}, y()(e.byId[t.id], "error"), {
                                            isChanged: !1,
                                            isUsed: !1
                                        })))
                                    }
                                })
                            }
                    }
                    ,
                    r
            }
            t.a = c;
            var f = r(0)
                , l = r.n(f)
                , p = r(1)
                , b = r.n(p)
                , d = r(8)
                , y = r.n(d)
                , h = function () {
                    function e(e, t) {
                        for (var r = 0; r < t.length; r++) {
                            var n = t[r];
                            n.enumerable = n.enumerable || !1,
                                n.configurable = !0,
                                "value" in n && (n.writable = !0),
                                Object.defineProperty(e, n.key, n)
                        }
                    }
                    return function (t, r, n) {
                        return r && e(t.prototype, r),
                            n && e(t, n),
                            t
                    }
                }()
                , v = function (e) {
                    return "radio" === e.props.type || "checkbox" === e.props.type
                }
        }
        , function (e, t) {
            e.exports = n
        }
        , function (e, t, r) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function o(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" !== typeof t && "function" !== typeof t ? e : t
            }
            function i(e, t) {
                if ("function" !== typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                    t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function a(e) {
                var t, r;
                return r = t = function (t) {
                    function r() {
                        return n(this, r),
                            o(this, (r.__proto__ || Object.getPrototypeOf(r)).apply(this, arguments))
                    }
                    return i(r, t),
                        l(r, [{
                            key: "shouldComponentUpdate",
                            value: function (e, t, r) {
                                return r._errors !== this.context._errors
                            }
                        }, {
                            key: "render",
                            value: function () {
                                var t = !!Object.keys(this.context._errors).length;
                                return u.a.createElement(e, Object.assign({}, this.props, {
                                    hasErrors: t
                                }))
                            }
                        }]),
                        r
                }(s.Component),
                    t.contextTypes = {
                        _errors: f.a.arrayOf(f.a.oneOfType([f.a.object, f.a.string]))
                    },
                    t.displayName = "Button(" + e.name + ")",
                    r
            }
            t.a = a;
            var s = r(0)
                , u = r.n(s)
                , c = r(1)
                , f = r.n(c)
                , l = function () {
                    function e(e, t) {
                        for (var r = 0; r < t.length; r++) {
                            var n = t[r];
                            n.enumerable = n.enumerable || !1,
                                n.configurable = !0,
                                "value" in n && (n.writable = !0),
                                Object.defineProperty(e, n.key, n)
                        }
                    }
                    return function (t, r, n) {
                        return r && e(t.prototype, r),
                            n && e(t, n),
                            t
                    }
                }()
        }
        , function (e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = r(7);
            r.d(t, "form", function () {
                return n.a
            });
            var o = r(2);
            r.d(t, "control", function () {
                return o.a
            });
            var i = r(9);
            r.d(t, "button", function () {
                return i.a
            })
        }
    ])
});